// Record Actions
export const FETCH_RECORD_REQUEST = 'FETCH_RECORD_REQUEST';
export const FETCH_RECORD_SUCCESS = 'FETCH_RECORD_SUCCESS';
export const FETCH_RECORD_FAILURE = 'FETCH_RECORD_FAILURE';
export const PUT_INIT_RECORD = 'PUT_INIT_RECORD';
export const CLEAN_STORE = 'CLEAN_STORE';
export const OPEN_RECORD = 'OPEN_RECORD';

export const FETCH_OFFER_REQUEST = 'FETCH_OFFER_REQUEST';
export const FETCH_OFFER_SUCCESS = 'FETCH_OFFER_SUCCESS';
export const FETCH_OFFER_FAILURE = 'FETCH_OFFER_FAILURE';

export const POST_OFFER_REQUEST = 'POST_OFFER_REQUEST';
export const POST_OFFER_SUCCESS = 'POST_OFFER_SUCCESS';
export const POST_OFFER_FAILURE = 'POST_OFFER_FAILURE';

export const UPDATE_OFFER_REQUEST = 'UPDATE_OFFER_REQUEST';
export const UPDATE_OFFER_SUCCESS = 'UPDATE_OFFER_SUCCESS';
export const UPDATE_OFFER_FAILURE = 'UPDATE_OFFER_FAILURE';

export const POST_PARTNER_REQUEST = 'POST_PARTNER_REQUEST';
export const PUT_PARTNER_REQUEST = 'PUT_PARTNER_REQUEST';

export const FETCH_PRICING = 'FETCH_PRICING';
export const FETCH_VEHICLE_VERSIONS = 'FETCH_VEHICLE_VERSIONS';
export const SAVE_USER_PRICING = 'SAVE_USER_PRICING';
export const POST_PRICING_REQUEST = 'POST_PRICING_REQUEST';
export const POST_PRICING_FAILURE = 'POST_PRICING_FAILURE';
export const FETCH_PREFERENCES_SUCCESS = 'FETCH_PREFERENCES_SUCCESS';
export const FETCH_QUOTATION_SUCCESS = 'FETCH_QUOTATION_SUCCESS';
export const CURRENT_TAB = 'CURRENT_TAB';
export const RESET_STATE = 'RESET_STATE';
export const FETCH_PRICINGHISTORY_SUCCESS = 'FETCH_PRICINGHISTORY_SUCCESS';
export const FETCH_PRICINGHISTORY_FAILURE = 'FETCH_PRICINGHISTORY_FAILURE';
export const POST_COVERAGEFORD_REQUEST = 'POST_COVERAGEFORD_REQUEST';
export const POST_COVERAGEFORD_SUCCESS = 'POST_COVERAGEFORD_SUCCESS';
export const SET_OFFERS_SALES = 'SET_OFFERS_SALES';
export const GET_TRADE = 'GET_TRADE';

export const UPDATE_RECORD_SUCCESS = 'UPDATE_RECORD_SUCCESS';
export const REINITIALISE_OFFERAT_SUCCESS = 'REINITIALISE_OFFERAT_SUCCESS';
export const SET_ENTRY_STOCK_OPTION = 'SET_ENTRY_STOCK_INFO';
export const SET_RECORD_CONFIG_FORM = 'SET_RECORD_CONFIG_FORM';

export const FETCH_SOURCE_INFO = 'FETCH_SOURCE_INFO';
export const FETCH_EXTERNAL_REF_REQUEST = 'FETCH_EXTERNAL_REF_REQUEST';

export const POST_COUNTER_OFFER_REQUEST = 'POST_COUNTER_OFFER_REQUEST';
export const PUT_COUNTER_OFFER_REQUEST = 'PUT_COUNTER_OFFER_REQUEST';

export const POST_PURCHASE_ORDER_REQUEST = 'POST_PURCHASE_ORDER_REQUEST';
export const POST_PURCHASE_ORDER_FAILURE = 'POST_PURCHASE_ORDER_FAILURE';
export const POST_PURCHASE_ORDER_SUCCESS = 'POST_PURCHASE_ORDER_SUCCESS';
export const FETCH_Buyers_INFO = 'FETCH_Buyers_INFO';
export const POST_PICKUP_SITES = 'POST_PICKUP_SITES';
